export default "__VITE_ASSET__5d065d7f__"